import * as u from './utils';
import StickySidebar from 'sticky-sidebar-v2';

export default () => {
    const container = document.querySelectorAll('.stepping-images');

    if (!container) {
        return;
    }

    for (const el of container) {
        const images = Array.prototype.slice.call(el.querySelectorAll('.stepping-images__image'));
        const items = Array.prototype.slice.call(el.querySelectorAll('.stepping-images__content'));
        const reverseItems = items.slice().reverse();
        let sidebar;

        const handleScroll = () => {
            let activeIndex = reverseItems.length - 1;
            for (let i = 0; i < reverseItems.length; i++) {
                if (reverseItems[i].getBoundingClientRect().top < window.innerHeight / 1.5) {
                    //u.addClass(item, 'is-active');
                    activeIndex = i;
                    break;
                }
            }
            activeIndex = reverseItems.length - activeIndex - 1;

            u.removeClass(images, 'is-active');
            u.addClass(images[activeIndex], 'is-active');

            if (activeIndex > 0) {
                u.addClass(images[activeIndex - 1], 'is-active');
            }
        };

        const handleResize = (query) => {
            if (query.matches) {
                if (sidebar && typeof sidebar.destroy !== undefined) {
                    window.removeEventListener('scroll', handleScroll);
                    sidebar.destroy();
                }
            } else {
                window.addEventListener('scroll', handleScroll);
                sidebar = new StickySidebar(el.querySelector('.stepping-images__images'), {
                    topSpacing: document.querySelector('.header').offsetHeight + 20,
                    bottomSpacing: 0,
                    containerSelector: '.stepping-images__stepper',
                    innerWrapperSelector: '.stepping-images__images-inner',
                });
            }
        };

        const query = window.matchMedia('(max-width: 600px)');
        handleResize(query);
        query.addListener(handleResize);
    }
};
